var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.605 17.15L19.95 11.2L10.605 5.25V17.15ZM8.75 25.2V22.4H2.1C1.54 22.4 1.05 22.19 0.63 21.77C0.21 21.35 0 20.86 0 20.3V2.1C0 1.54 0.21 1.05 0.63 0.63C1.05 0.21 1.54 0 2.1 0H25.9C26.46 0 26.95 0.21 27.37 0.63C27.79 1.05 28 1.54 28 2.1V20.3C28 20.86 27.79 21.35 27.37 21.77C26.95 22.19 26.46 22.4 25.9 22.4H19.25V25.2H8.75ZM2.1 20.3H25.9V2.1H2.1V20.3Z",
    fill: "#5E5E5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVideo);
export default __webpack_public_path__ + "static/media/icon-video.06dd171969346a1e757527981ed1a3bc.svg";
export { ForwardRef as ReactComponent };